import { usePermission } from '@circlefin/permissions/context'
import { MULTI_ENTITY_ENABLED } from '@services/permissions'

import { EntitySwitcherMenu } from './EntitySwitcher.Menu/EntitySwitcher.Menu'

import type { EntitySwitcherMenuProps } from './EntitySwitcher.Menu/EntitySwitcher.Menu'

export const EntitySwitcher: React.FC<EntitySwitcherMenuProps> = (props) => {
  const [{ Authorized }] = usePermission(MULTI_ENTITY_ENABLED)

  return (
    <Authorized>
      <EntitySwitcherMenu {...props} />
    </Authorized>
  )
}
